import { Sort } from '@angular/material/sort';
import { ModuleUser } from '../../module-user/models/module-user.model';

export class SetMyUnpublishedModules {
    static readonly type = '[MyUnpublishedModules] SetMyUnpublishedModules';

    constructor(public payload: ModuleUser[]) {}
}

export class UnsetMyUnpublishedModules {
    static readonly type = '[MyUnpublishedModules] UnsetMyUnpublishedModules';
}

export class AddMyUnpublishedModules {
    static readonly type = '[MyUnpublishedModules] AddMyUnpublishedModules';

    constructor(public payload: ModuleUser[]) {}
}

export class FetchMyUnpublishedModule {
    static readonly type = '[MyUnpublishedModules] FetchMyUnpublishedModule';

    constructor(public payload: string) {}
}

export class FetchMyUnpublishedModules {
    static readonly type = '[MyUnpublishedModules] FetchMyUnpublishedModules';

    constructor(
        public payload?: {
            category: string;
            search?: string;
            sortBy?: string;
            sortOrder?: string;
            pageSize?: number;
            pageNumber?: number;
            isRunning?: boolean;
            participantId?: string;
            tag: number[];
        }
    ) {}
}

export class FetchMyUnpublishedModulesSuccess {
    static readonly type = '[MyUnpublishedModules] FetchMyUnpublishedModulesSuccess';
}

export class FetchMyUnpublishedModulesFailure {
    static readonly type = '[MyUnpublishedModules] FetchMyUnpublishedModulesFailure';
}

export class ToggleSelectedModule {
    static readonly type = '[MyUnpublishedModules] ToggleSelectedModule';

    constructor(public payload: string) {}
}

export class SelectFilteredModules {
    static readonly type = '[MyUnpublishedModules] SelectFilteredModules';
}

export class DeselectSelectedModules {
    static readonly type = '[MyUnpublishedModules] DeselectSelectedModules';
}

export class SearchMyUnpublishedModules {
    static readonly type = '[MyUnpublishedModules] SearchMyUnpublishedModules';

    constructor(public payload: string) {}
}

export class SortMyUnpublishedModules {
    static readonly type = '[MyUnpublishedModules] SortMyUnpublishedModules';

    constructor(public payload: Sort) {}
}
